import { config } from "../config";

import { remoteConfigRequest } from "./api.service";
import { Store } from "../services/app.store.service";

export class RemoteConfigService {
  static setConfig(remoteConfig) {
    if (remoteConfig.appConfig) {
      const { appConfig } = remoteConfig;

      const patchMap = {
        appConfig,
      };

      Object.keys(patchMap).forEach(key => {
        config[key] = patchMap[key];
      });
    }
  }

  static async initialize() {
    const remoteConfig = await this.requestRemoteConfig().catch(error => {
      console.error(error);
      throw error;
    });
    if (remoteConfig) {
      await this.setConfig(remoteConfig);
      Store.localizationData = remoteConfig["localization"];
      return config;
    }
  }

  static async requestRemoteConfig() {
    const response = await remoteConfigRequest().catch(error => {
      console.error(error);
      throw error;
    });
    if (response && response.data) {
      return response.data;
    }
  }
}
